<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="model.statistics"
      class="elevation-1 mb-7"
      no-data-text="No hay registros agregados..."
      hide-default-footer
    >
      <template v-slot:top v-if="edit">
        <v-toolbar flat>
          <v-toolbar-title>Estadísticas</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Dialog add supervisor -->
          <v-dialog v-model="dialogAdd" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Agregar
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ titleDialog }} Estadística</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="form" v-model="formAdd">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          :items="typeStatistics"
                          v-model="modelStatistics.type"
                          label="TIPO"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="modelStatistics.internal_population_served"
                          label="POBLACIÓN INTERNA ATENDIDA"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-left">GENERO</h4>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="modelStatistics.feminine"
                          label="FEMENINO"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="modelStatistics.masculine"
                          label="MASCULINO"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-left">ACTORES CDC</h4>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.coordinators"
                          label="COORDINADORES"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.counsellors"
                          label="ORIENTADORES"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.socializers"
                          label="SOCIALIZADORES"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-left">MODALIDAD</h4>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.performing_arts"
                          label="ARTES ESCENICAS"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.plastic_arts"
                          label="ARTES PLASTICAS"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="modelStatistics.arts_crafts"
                          label="ARTES Y OFICIOS"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="modelStatistics.dance"
                          label="DANZA"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="modelStatistics.music"
                          label="MUSICA"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="modelStatistics.literature"
                          label="LITERATURA"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="modelStatistics.makeup"
                          label="MAQUILLAJE"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-left">CASOS REMITIDOS</h4>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="modelStatistics.cases_referred"
                          label="CASOS REMITIDOS"
                          required
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-left">OBSERVACIONES</h4>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-textarea
                          v-model="modelStatistics.observations"
                          label="OBSERVACIONES"
                          required
                          type="number"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  {{ titleDialog }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog delete supervisor -->
          <v-dialog v-model="dialogDelete" max-width="520px">
            <v-card>
              <v-card-title class="headline"
                >Seguro que desea eliminar esta estadísticas?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteConfirm"
                  >Aceptar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.type`]="item">
        {{ getTypeStatistics(item.item.type) }}
      </template>
      <template v-slot:[`item.actions`]="item">
        <v-tooltip bottom v-if="edit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="deleteStatistics(item.item)"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <span v-else>N/A</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_ALERT } from "@/store/alert";
export default {
  name: "Statistics",
  props: {
    model: {
      type: Object,
      required: true,
    },
    charge: {
      required: true,
    },
    typeStatistics: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    current: null,
    formAdd: true,
    dialogAdd: false,
    editedIndex: -1,
    dialogDelete: false,
    modelStatistics: {
      type: "",
      internal_population_served: 0,
      feminine: 0,
      masculine: 0,
      coordinators: 0,
      counsellors: 0,
      socializers: 0,
      performing_arts: 0,
      plastic_arts: 0,
      arts_crafts: 0,
      dance: 0,
      music: 0,
      literature: 0,
      makeup: 0,
      cases_referred: 0,
      observations: "",
    },
    headers: [
      { text: "Tipo", value: "type", sortable: false },
      { text: "P.I.A", value: "internal_population_served", sortable: false },
      { text: "F", value: "feminine", sortable: false },
      { text: "M", value: "masculine", sortable: false },
      { text: "C", value: "coordinators", sortable: false },
      { text: "O", value: "counsellors", sortable: false },
      { text: "S", value: "socializers", sortable: false },
      { text: "A.E", value: "performing_arts", sortable: false },
      { text: "A.P", value: "plastic_arts", sortable: false },
      { text: "A.O", value: "arts_crafts", sortable: false },
      { text: "D", value: "dance", sortable: false },
      { text: "M", value: "music", sortable: false },
      { text: "L", value: "literature", sortable: false },
      { text: "M", value: "makeup", sortable: false },
      { text: "C.R", value: "cases_referred", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(["getTypeStatistics"]),
    titleDialog() {
      return this.current ? "Editar" : "Agregar";
    },
  },
  methods: {
    deleteStatistics(item) {
      this.editedIndex = this.model.statistics.indexOf(item);
      this.dialogDelete = true;
    },
    deleteConfirm() {
      this.model.statistics.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.modelStatistics = {
          type: "",
          internal_population_served: 0,
          feminine: 0,
          masculine: 0,
          coordinators: 0,
          counsellors: 0,
          socializers: 0,
          performing_arts: 0,
          plastic_arts: 0,
          arts_crafts: 0,
          dance: 0,
          music: 0,
          literature: 0,
          makeup: 0,
          cases_referred: 0,
          observations: "",
        };
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.current = null;
        this.editedIndex = -1;
      });
    },
    save() {
      //Validate inputs
      if (!this.modelStatistics.internal_population_served) {
        this.$store.commit(SET_ALERT, {
          message: "Debe ingresar la población atendidos",
          type: "error",
        });
        return;
      }
      //validate if type is not added
      if (
        this.model.statistics.find(
          (obj) => obj.type == this.modelStatistics.type
        )
      ) {
        this.$store.commit(SET_ALERT, {
          message: "No se puede agregar dos estadisticas del mismo tipo",
          type: "error",
        });
        return;
      }
      this.model.statistics.push(this.modelStatistics);
      this.close();
    },
  },
};
</script>

<style>
</style>